import {useSelector} from "react-redux";
import {LocalizerHelper} from "../../helpers/localizerHelper";
import {formatPrice} from "../../helpers/formatHelper";
import './index.scss';
import { RootState } from "../../store";
import { DeliveryMeasureType } from "../../models/restaurant";

interface InfoDetailsDeliveryParams {
  deliveryCost: number;
}

const InfoDetailsDelivery = ({deliveryCost}: InfoDetailsDeliveryParams) => {
  const restaurant = useSelector((state: RootState) => state.restaurant.restaurant);

  if(restaurant == null) return null;
  const address = restaurant.address;
  const max_delivery_distance = restaurant.max_delivery_distance;
  const price = restaurant.delivery_cost ?? 0;
  const freeDeliveryMinimumAmount = restaurant.free_delivery_minimum_amount ?? 0;
  const priceFreeDelivery = formatPrice(freeDeliveryMinimumAmount);
  const maxRangeDefault: number = restaurant.min_range_free ?? 0;
  const unitDeliveryCost: number = restaurant.delivery_cost ?? 0;
  const deliveryMeasureType: DeliveryMeasureType = restaurant.delivery_measure_type ?? DeliveryMeasureType.DEFAULT;
  const deliveryMeasureCost: number = restaurant.delivery_measure_cost ?? 0;
  //const deliveryMessage = LocalizerHelper.localized(data, 'delivery_message') ?? data.delivery_message ?? null;
  let deliveryMessage: string = "";
  if(deliveryMeasureType != DeliveryMeasureType.DEFAULT){
    deliveryMessage = `${formatPrice(unitDeliveryCost)} + ${formatPrice(deliveryMeasureCost)} ${LocalizerHelper.localized('at')} ${deliveryMeasureType.toString()} ${LocalizerHelper.localized('to_deliver_over')} ${maxRangeDefault} km`
  }
  
  return (
    <div className="container container-info-delivery">
      {max_delivery_distance > 0 &&
        <div className="row">
          <div className="col-6 text-left label">{LocalizerHelper.localized('radius_delivery')}</div>
          <div className="col-6 text-left">{max_delivery_distance} Km {LocalizerHelper.localized('address_from')} {address}</div>
        </div>
      }

      {(!!deliveryMessage && deliveryMessage.trim()!== "") &&
        <div className="row">
          <div className="col-6 text-left label">{LocalizerHelper.localized('delivery_message')}</div>
          <div className="col-6 text-left">{deliveryMessage} <i> {LocalizerHelper.localized('or_fractions')}</i></div>
        </div>
      }

      <div className="row">
        <div className="col-6 text-left label">{LocalizerHelper.localized('delivery_cost')}</div>
        <div className="col-6 text-left">{formatPrice(deliveryCost)}</div>
      </div>

      { price>0 && freeDeliveryMinimumAmount > 0 &&
        <div className="row">
          <div className="col-6 text-left label">{LocalizerHelper.localized('bottom_order_recap_free_delivery_minimum_amount')}</div>
          <div className="col-6 text-left">{priceFreeDelivery}</div>
        </div>
      }
    </div>
  );
};

export default InfoDetailsDelivery;